






import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Catalog {
    document: {
        name: string;
        link: string;
        uuid: string;
    };
}

@Component({components: {SimpleText}})
export default class Edit extends Vue {
    @Prop({default: null}) public catalog !: Catalog;

    public static getNeededFields(): string[] {
        return [
            "catalog.document.link",
            "catalog.document.uuid",
        ];
    }

    public editCatalog() {
        this.$emit("edit-catalog", this.catalog);
    }
}
